import React, {useEffect, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form,
    FormGroup, Input, Label, Row, InputGroup, Button, InputGroupAddon
} from 'reactstrap';
import {ErrorMessage, useForm} from "react-hook-form";
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import {connect, useSelector} from "react-redux";

// components
import ImagePicker from "../../../../components/imagePickerComponents/ImagePicker";
import {ConfirmDelete} from "../../../../components/confirmAlert/ConfirmDelete";
import {GenericButton} from "../../../../components/buttons/customButtons";
import SelectGeneric from "../../../../components/select/selectGeneric";
import PlaceLangs from "../../../core/place/_langs";
import Separator from "../../../../components/Separator";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import {MapPickerModal} from "../../../../components/map/MapPickerModal";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";

// labels
import {INTERNATIONAL, REQUIRED} from "../../../../components/i18n/i18n";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../../components/i18n/toolTips";

// services & providers
import {placeService} from "../../../../jwt/_services/hotel/placeService";
import {placeMediaService} from "../../../../jwt/_services/core/placeMediaService";
import {hotelCategoryProvider} from "../../../../providers/hotelCategoryProvider";

// actions
import {setForm, setItem} from "../../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";

const HomePlaceForm = ( props ) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, editMode, domainObject, mapConfig} = componentState?.data;

    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState( domainObject?.status || false);
    const [weather, setWeather] = useState( domainObject?.weather || false);
    const [needReservation, setNeedReservation] = useState( domainObject?.needReservation || false);
    const [category, setCategory] = useState( domainObject?.category || null);
    const [contactCategory, setContactCategory] = useState( domainObject?.contactCategory || null);
    const [parentPlace, seParentPlace] = useState( domainObject?.parentPlace || null);
    const [typePlace, setTypePlace] = useState( domainObject?.typePlace || null);
    const [position, setPosition] = useState(editMode ? {
        lat: parseFloat(domainObject?.latitude),
        lng: parseFloat(domainObject?.longitude)
    } : mapConfig?.mapOptions?.center );

    const [langs, setLangs] = useState(domainObject?.langs || []);


    const [showGeneral, setShowGeneral] = useState('regular'); // minimized | regular
    const [showFullGeneral, setShowFullGeneral] = useState(false); // minimized | regular
    const [showInternational, setShowInternational] = useState('regular'); // minimized | regular

    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const [showMapModal, setShowMapModal] = useState(true);
    const modalHistoryRef = useRef(null);
    const modalMapRef = useRef(null);


    // Actualiza el formulario con los datos del objeto de dominio
    // Se utiliza posterior a la carga de imagenes desde ImagePicker ejecutando el metodo refresh()
    useEffect(() => {
        if (domainObject && domainObject.id && domainObject.langs) {
            reset({
                id: domainObject?.id,
                uid: domainObject?.uid,
                code: domainObject?.code,
                status: domainObject?.status,
                needReservation: domainObject?.needReservation,
                colorMarkerMap: domainObject?.colorMarkerMap,
                iconMap: domainObject?.iconMap,
                latitude: domainObject?.latitude ?? 0.0,
                longitude: domainObject?.longitude ?? 0.0,
                level: domainObject?.level,
                showOrder: domainObject?.showOrder,
                houseId: domainObject?.houseId,
                floors: domainObject?.floors,
                totalSuits: domainObject?.totalSuits,
                menuFontColor: domainObject?.menuFontColor,
                menuBackgroundColor: domainObject?.menuBackgroundColor,
                menuBackground: domainObject?.menuBackground,
                menuLogo: domainObject?.menuLogo,
                menuSignature: domainObject?.menuSignature,
            })
            setLangs(domainObject.langs || []);
            setStatus(domainObject.status);
        }
    }, [ domainObject ]);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const showMap = () => {
        setShowMapModal(true);
        modalMapRef.current.showModal(mapConfig);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED),

    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: domainObject?.code,
            status: domainObject?.status,
            needReservation: domainObject?.needReservation,
            colorMarkerMap: domainObject?.colorMarkerMap,
            iconMap: domainObject?.iconMap,
            latitude: domainObject?.latitude ?? 0.0,
            longitude: domainObject?.longitude ?? 0.0,
            level: domainObject?.level,
            showOrder: domainObject?.showOrder,
            houseId: domainObject?.houseId,
            floors: domainObject?.floors,
            totalSuits: domainObject?.totalSuits,
            menuFontColor: domainObject?.menuFontColor,
            menuBackgroundColor: domainObject?.menuBackgroundColor,
            menuBackground: domainObject?.menuBackground,
            menuLogo: domainObject?.menuLogo,
            menuSignature: domainObject?.menuSignature,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase :  { id : app?.fbDataBase?.id },
            item : {
                ...data,
                id: domainObject?.id,
                udn: {id: udn?.id},

                latitude: position?.lat,
                longitude: position?.lng,

                weather: weather,
                status: status,
                needReservation: needReservation,

                langs: langs,
            }
        };

        if (category)
            dataRequest.item.category = { id: category };

        if (contactCategory)
            dataRequest.item.contactCategory = { id: contactCategory };

        if (parentPlace)
            dataRequest.item.parentPlace = { id: parentPlace };

        if (typePlace)
            dataRequest.item.typePlace = { id: typePlace };


        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, placeService, id, dataRequest);
        } else {
            genericIndexedActions.save(path, placeService, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, );
        props.onClose()
    }

    const onLatChange = (value ) => {
        setPosition({
            ...position,
            lat : value
        })
    }

    const onLngChange = ( value ) => {
        setPosition({
            ...position,
            lng : value
        })
    }

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: placeService
        } );
    };

    const returnToList = () => {
        reset();
        props.setForm(path, false, false, false);
        props.onClose();
    }

    const refreshObject = () => genericIndexedActions.get(path, placeService, domainObject?.id, app?.fbDataBase?.id);

    return (<>
            <Form onSubmit={ handleSubmit(onSubmit) }>
                <Card className={'card-modal-medium-ex'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <>
                            <h2 className={'card-modal-title'} > { app.name + '  /  ' + udn.value  }</h2>
                            <br />
                            <h5 className={'card-modal-uid'} > { '     uid: ' + (domainObject?.uid || '' ) }</h5>
                        </>
                        <div className="top-right">
                            <GenericButton
                                style={'table'}
                                icon={'fa-save'}
                                toolTip={TT_SAVE}
                                permission={'add'}
                                type={'submit'}
                            />
                            {
                                editMode &&
                                <>
                                    <GenericButton
                                        style={'table'}
                                        toolTip={TT_HISTORY}
                                        icon={'fa-clock'}
                                        permission={'search'}
                                        onClick={showHistory}
                                    />
                                    <TranslateButton item={domainObject} service={placeService} />
                                    <GenericButton
                                        style={'danger-secondary'}
                                        toolTip={TT_DELETE}
                                        icon={'fa-trash'}
                                        permission={'delete'}
                                        onClick={_ => confirmDelete(domainObject)}
                                    />
                                </>
                            }
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={returnToList}
                            />
                        </div>
                    </CardTitle>
                    <CardBody className={'card-body-modal'}>

                        <Row>
                            <Col md="6">
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Código</Label>
                                            <Input
                                                type="text"
                                                name="code"
                                                placeholder="Código"
                                                innerRef={register}
                                                className={(errors.code ? ' is-invalid' : '')}
                                            />
                                            { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Categoría de contacto</Label>
                                            <br/>
                                            <SelectGeneric
                                                initialValue={ contactCategory }
                                                setExternalValue={ setContactCategory }
                                                provider={hotelCategoryProvider}
                                                getAllCategories={true}
                                            />
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Latitud y longitud</Label>
                                            <InputGroup>
                                                <Button color=" background-color-primary" onClick={ showMap } >
                                                    <i className="fas fa-map-marker-alt text-white"/>
                                                </Button>
                                                <InputGroupAddon addonType="append">
                                                    <Input type="number"
                                                           name="lat"
                                                           value={position?.lat}
                                                           className={'lat-lng-input'}
                                                           step={'0.0000001'}
                                                           onChange={e => onLatChange(e.target.value)}
                                                    />
                                                </InputGroupAddon>
                                                <InputGroupAddon addonType="append">
                                                    <Input type="number"
                                                           name="lng"
                                                           className={'lat-lng-input'}
                                                           value={ position?.lng}
                                                           step={'0.0000001'}
                                                           onChange={e => onLngChange(e.target.value)}
                                                    />
                                                </InputGroupAddon>
                                            </InputGroup>
                                            <ErrorMessage errors={errors} name="latitude" component="div"
                                                          className="invalid-feedback"/>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    {/*<Col  md="4">*/}
                                    {/*    <FormGroup>*/}
                                    {/*        <Label>Orden</Label>*/}
                                    {/*        <Input*/}
                                    {/*            type="number"*/}
                                    {/*            name="showOrder"*/}
                                    {/*            min="1"*/}
                                    {/*            placeholder="Orden"*/}
                                    {/*            innerRef={register}*/}
                                    {/*        />*/}
                                    {/*    </FormGroup>*/}
                                    {/*</Col>*/}
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Color</Label>
                                            <div className="form-control-color-input">
                                                <Input type="color" name="color" id="color"
                                                       innerRef={register}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label>Activo</Label>
                                            <br/>
                                            <Switch
                                                animate={true}
                                                offText={"No"}
                                                onText={"Si"}
                                                value={ status }
                                                onChange={ _ => setStatus(!status) }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md="6">
                                { domainObject?.id &&
                                    <ImagePicker
                                        className={'place'}
                                        title={'Restaurante Media'}
                                        app={app}
                                        service={placeService}
                                        baseMediaService={placeMediaService}
                                        objectMedia={domainObject}
                                        afterUpload={refreshObject}
                                    />
                                }
                            </Col>
                        </Row>
                        <Row>
                        </Row>
                        <CardTitle className="bg-light border-bottom p-3 mb-0">
                            <i className="far fa-edit mr-2"/>{INTERNATIONAL}
                        </CardTitle>
                        <CardBody>
                            <PlaceLangs appCode={app?.code} langs={langs} setLangs={setLangs} translatableLangs={translatableLangs} />
                        </CardBody>
                    </CardBody>
                </Card>
            </Form>
            {
                showMapModal && <MapPickerModal
                    ref={modalMapRef}
                    setPosition={setPosition}
                    initialPosition={position}
                    googleConfig={mapConfig}
                    updateMarkerPosition={true}
                />
            }
            {
                showHistoryModal && <LogHistoryModal
                    ref={ modalHistoryRef }
                    item={ domainObject }
                />
            }
        </>
    )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(HomePlaceForm)
